<template>
	<aside class="sidebar" :class="{ 'opened': opened, 'animate-sidebar': animate }">
		<router-link v-if="isDesktop" class="sidebar__top" :to="{ name: 'Dashboard' }">
			<img src="@/assets/images/icon-light.svg" />
		</router-link>
		<span v-else class="sidebar__head">
			<Logo />
			<svg @click="close()" class="icon-button stroke" viewBox="0 0 24 24">
				<path d="M4.222 4.222l15.556 15.556M4.222 19.778L19.778 4.222"></path>
			</svg>
		</span>
		<nav class="navigation navigation--primary">
			<b-tooltip v-for="(r, i) in primary" :label="title(r)" :key="i" class="is-capitalized" type="is-white" position="is-right" v-show="verifyShowMenu(r.name)">
				<router-link class="navigation__link" @click.native="close()" :to="r">
					<span v-if="!isDesktop" class="is-capitalized">{{ title(r) }}</span>
					<svg-icon v-else :icon="r.icon"></svg-icon>
				</router-link>
			</b-tooltip>
		</nav>
		<nav class="navigation navigation--secondary">
			<b-tooltip :label="$t('profile')" type="is-white" position="is-right">
				<router-link class="navigation__link" @click.native="close()" :to="{ name: 'Perfil' }">
					<span v-if="!isDesktop">{{ $t('profile') }}</span>
					<svg-icon v-else icon="profile"></svg-icon>
				</router-link>
			</b-tooltip>
			<b-tooltip :label="$t('log_out')" type="is-white" position="is-right">
				<a @click="logout" class="navigation__link navigation__link--logout">
					<span v-if="!isDesktop">{{ $t('log_out') }}</span>
					<svg-icon v-else icon="logout"></svg-icon>
				</a>
			</b-tooltip>
		</nav>
	</aside>
</template>

<script>
import Menu from '@/router/menu'
import Logo from '@/components/Logo'
import Icon from '@/components/Icon'
import Api from '@/services/api'
import eventHub from '@/services/eventHub'
import { responsive } from '@/mixins/responsive'
import { mapActions, mapState } from 'vuex'

export default {
	name: 'Sidebar',
	mixins: [responsive],
	components: {
		Logo,
		'svg-icon': Icon
	},
	data() {
		return {
			expandOnHover: false,
			animate: false,
			opened: false,
			overlay: false,
			id: ''
		}
	},
	methods: {
		...mapActions('user', ['getUserData', 'deleteUserData']),
		close() {
			this.opened = false
			eventHub.$emit('close-menu')
		},
		title(r) {
			return r.meta ? this.$t(r.meta.title) : this.$t(r.name)
		},
		async logout(event) {
			try {
				event.preventDefault()
				await Api.post('user/logout')
			} catch (e) {
				console.log(e)
			}

			this.deleteUserData()
			this.$router.push('/')
			
			eventHub.$emit('close-menu')
			eventHub.$emit('animate-login')
		},
		verifyShowMenu(name) {
			if (this.permissions) {
				const menu = this.permissions.find(e => e.slug === name.toLowerCase())

				if (menu) {
					return menu.role.read
				}
			}

			return false
		}
	},
	created() {
		this.getUserData()
	},
	mounted() {
		eventHub.$on('open-menu', () => {
			this.opened = true
		})
		eventHub.$on('animate-dashboard', () => {
			this.animate = true
		})
	},
	watch: {
		permissions (v) {
			if (v) {
				const endpoint = window.location.href.split('/')[3]
				const permission = this.permissions.find(e => e.slug === endpoint.toLowerCase())

				if (permission && !permission.role.read) {
					this.$router.push('/error')
				}
			}
		}
	},
	computed: {
		primary() {
			return Menu
		},
		...mapState('user', [
			'user',
			'permissions'
		])
	}
}
</script>
